/** Dev-only logging — stripped from merchant-facing production builds. */

const isDev = process.env.NODE_ENV === "development";

export function devLog(...args) {
  if (isDev) console.log(...args);
}

export function devInfo(...args) {
  if (isDev) console.info(...args);
}

export function devWarn(...args) {
  if (isDev) console.warn(...args);
}
